/* Aflairza: round shade swatches on product pages.
   Colours come from Shopify's native option swatches, then from the saved colour-swatch app settings. */
(function () {
  var NONE = 'linear-gradient(135deg, #ffffff 0%, #eceef2 55%, #d3d9e1 100%)';
  var cache = null;
  function parse(sel) {
    var el = document.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function load() {
    if (cache) return cache;
    var nat = parse('script.af-swatch-data');
    if (!nat) return null;
    var app = {}, raw = parse('script.af-swatch-app');
    if (raw && raw.length) {
      for (var i = 0; i < raw.length; i++) {
        var o = raw[i], items = o && o.option_items;
        if (!items || !o.name) continue;
        var k = String(o.name).trim().toLowerCase();
        app[k] = app[k] || {};
        for (var j = 0; j < items.length; j++) {
          var it = items[j], c = it.custom || {};
          var img = (c.enable_image_url && c.image_url && c.image_url.src) || (c.enable_upload_file && c.upload_file && c.upload_file.src) || '';
          var col = c.color_1 && c.color_1 !== 'transparent' ? c.color_1 : '';
          if (c.enable_two_color && c.color_2 && c.color_2 !== 'transparent' && col) img = 'linear-gradient(135deg, ' + col + ' 50%, ' + c.color_2 + ' 50%)';
          else if (img) img = 'url("' + img + '")';
          if (col || img) app[k][String(it.value).trim().toLowerCase()] = { c: col, g: img };
        }
      }
    }
    cache = { nat: nat, app: app };
    return cache;
  }
  function lookup(d, ul, name) {
    var n = (d.nat[ul.getAttribute('data-option-index')] || {})[name];
    if (n && (n.c || n.i)) return { c: n.c, g: n.i ? 'url("' + n.i + '")' : '' };
    var li0 = ul.querySelector('li[data-option-value]');
    var on = ul.getAttribute('data-option-name') || (li0 && li0.getAttribute('data-option-value')) || '';
    var a = d.app[String(on).replace(/&amp;/g, '&').trim().toLowerCase()];
    return a ? a[String(name).trim().toLowerCase()] || null : null;
  }
  function apply() {
    var d = load();
    if (!d) return;
    var lists = document.querySelectorAll('.product__details .variants ul[data-option-index]');
    for (var i = 0; i < lists.length; i++) {
      var ul = lists[i];
      var items = ul.querySelectorAll('li.option-item');
      var any = false, j, li, s;
      for (j = 0; j < items.length; j++) {
        if (lookup(d, ul, items[j].getAttribute('data-swatch') || '')) { any = true; break; }
      }
      if (!any) continue;
      ul.classList.add('af-dots');
      for (j = 0; j < items.length; j++) {
        li = items[j];
        if (li.classList.contains('af-dot')) continue;
        var name = li.getAttribute('data-swatch') || '';
        s = lookup(d, ul, name) || {};
        li.classList.add('af-dot');
        if (s.c) li.style.setProperty('--af-dot', s.c);
        if (s.g) li.style.setProperty('--af-dot-img', s.g);
        else if (!s.c) li.style.setProperty('--af-dot-img', NONE);
        li.setAttribute('aria-label', name);
      }
      var lab = ul.previousElementSibling;
      if (lab && lab.classList.contains('label')) {
        var sp = lab.querySelector('.af-sel');
        if (!sp) { sp = document.createElement('span'); sp.className = 'af-sel'; lab.appendChild(sp); }
        var h = ul.querySelector('li.highlighted');
        var t = h ? (h.getAttribute('data-swatch') || '') : '';
        if (sp.textContent !== t) sp.textContent = t;
      }
    }
  }
  var raf = null;
  function schedule() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; apply(); }); }
  apply();
  document.addEventListener('DOMContentLoaded', apply);
  if (!document.querySelector('script.af-swatch-data') && document.readyState !== 'loading') return;
  new MutationObserver(schedule).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.variants li.option-item')) setTimeout(apply, 60);
  });
})();
